import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Button, Box, Dialog, DialogContent, Stack, Typography, Modal, Tooltip, IconButton, ButtonGroup, Grid } from '@mui/material'

import SummarizeIcon from '@mui/icons-material/Summarize';
import AssessmentIcon from '@mui/icons-material/Assessment';

import { selectViewInstanceById } from '../../../reducers/reuseable_vi';
import { useNavigate, createSearchParams } from 'react-router-dom'

const AssessmentPersonalReportButton = ( props) => {
    const row = props.row
    const navigate = useNavigate()
    const graphcolors = ['#c0c0c0', '#4eb748', '#E7C61E', '#E6323A']
    const { user: currentUser } = useSelector((state) => state.auth);
    const viewInstance = useSelector(state => selectViewInstanceById(state, "ProfileDemographics"))
    const PrevAsmtsText = viewInstance?.ProfileVI?.MenuProfile?.PreviousAssessmentsFrame.PreviousAssessmentTextObject ?
        viewInstance.ProfileVI.MenuProfile.PreviousAssessmentsFrame.PreviousAssessmentTextObject
        : {}
    
        const handlePRClick = (row) => {
            if (row.AssmtGuid) {
    
                fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + row.AssmtGuid + '/', {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: {
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        navigate({ pathname: '/personalreport', search: createSearchParams({ vi: '8AC17D1E-2871-44D9-ACC0-867285149337' }).toString() })
                    })
            }
        }
    
        if (row.PrViGuid &&
            row.PrViGuid.length > 0) {
            return (
                <Tooltip title={PrevAsmtsText.GetPersReptText}>
                    <IconButton variant="text"
                        onClick={() => handlePRClick(row)}
                    >
                        <AssessmentIcon color="primary"/>
                    </IconButton>
                </Tooltip>
            )
        }
        else {
            return (
                <></>
            )
        }

}

export default AssessmentPersonalReportButton